var React = require('react');

function Stable (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"64/ads"},[React.createElement("path",{"d":"M0 8C0 3.58172 3.58172 0 8 0H40C44.4183 0 48 3.58172 48 8V40C48 44.4183 44.4183 48 40 48H8C3.58172 48 0 44.4183 0 40V8Z","fill":"#D0D4C2","key":0}),React.createElement("path",{"id":"Vector","d":"M36 24.5L33.3382 21.4443L33.7091 17.4029L29.7709 16.5048L27.7091 13L24 14.599L20.2909 13L18.2291 16.4938L14.2909 17.381L14.6618 21.4333L12 24.5L14.6618 27.5557L14.2909 31.6081L18.2291 32.5062L20.2909 36L24 34.39L27.7091 35.989L29.7709 32.4952L33.7091 31.5971L33.3382 27.5557L36 24.5ZM21.9164 29.6695L17.7709 25.4967L19.3855 23.8757L21.9164 26.4276L28.2982 19.9986L29.9127 21.6195L21.9164 29.6695Z","fill":"#676D73","key":1})]));
}

Stable.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Stable;

Stable.default = Stable;
